module.exports = __webpack_public_path__ + "static/media/acuizen-logo.39e40c4a.png";